import request from "../utils/request";

export const getToken = (params = {}) => {
  return request.post(`/api/user/token`, {
    ...params
  });
};

export const getQueue = (params = {}) => {
  return request.post(`/api/user/queue`, {
    ...params
  });
};

export const getAutoReplyMessage = (params = {}) => {
  return request.post(`/api/common/findAutoReply`, {
    ...params
  });
};
// 获取密钥解密的
export const getqueryCustomerKey = (params = {}) => {
  return request.post(`/api/common/queryCustomerKey`, {
    ...params
  });
};

// 发送消息
export const sendMsg = (params = {}) => {
  return request.post(`/api/user/msg`, {
    ...params
  });
};

// 会话标记已读
export const markChannelRead = (params = {}) => {
  return request.post(`/api/server/isRead`, {
    ...params
  });
};

export default {
  getToken,
  getQueue,
  getAutoReplyMessage,
  sendMsg,
  markChannelRead,
  getqueryCustomerKey
};
